var React = require('react');

function Mission (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m40.917 36.113-9.688-16.78a.625.625 0 0 0-1.082 0l-2.298 3.98-6.202-10.742V9.943h6.621a.626.626 0 0 0 .516-.979l-1.474-2.15 1.474-2.15a.625.625 0 0 0-.516-.98h-6.621v-.059a.625.625 0 0 0-1.25 0v8.945l-6.223 10.78-2.32-4.018a.625.625 0 0 0-1.082 0l-9.688 16.78a.625.625 0 0 0 .54.938h38.75a.625.625 0 0 0 .542-.938h.001ZM27.082 4.936 26.036 6.46a.626.626 0 0 0 0 .706l1.046 1.526h-5.435V4.935h5.435ZM2.708 35.8l8.605-14.904 5.18 8.971a.625.625 0 0 0 1.082-.625l-2.68-4.642 6.127-10.612 9.146 15.842a.625.625 0 0 0 1.083-.625l-2.68-4.642 2.117-3.668 8.605 14.904H2.708Z","fill":"#D22128","stroke":"#D22128","strokeWidth":".2"}));
}

Mission.defaultProps = {"width":"42","height":"40","fill":"none"};

module.exports = Mission;

Mission.default = Mission;
